// TeloSpravy — jediné miesto, kde sa v Matrixe zobrazuje telo prijatej správy (ústava 0.J).
// Správa sa ukáže celá, podpis a právna doložka sa zbalia pod jeden tichý riadok.
// Mirko 8. 10. 2026: „aby text — informácia, s ktorou pracujeme — bol v celom vlákne prehľadný."
import React, { useState } from 'react'
import { COLORS, TYPO, SPACE } from '../theme.js'
import { rozdelSpravu } from '../utils/emailTelo.js'

export default function TeloSpravy({ text, maxRiadkov = 0 }) {
  const [otvorene, setOtvorene] = useState(false)
  const d = rozdelSpravu(text)
  const [cele, setCele] = useState(false)
  const riadky = d.telo.split('\n')
  const dlhe = maxRiadkov > 0 && riadky.length > maxRiadkov
  const vidiet = dlhe && !cele ? riadky.slice(0, maxRiadkov).join('\n') : d.telo

  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ color: COLORS.text, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{vidiet}</div>
      {dlhe && !cele && (
        <button type="button" onClick={() => setCele(true)}
          style={{ border: 0, background: 'none', padding: '2px 0', font: 'inherit', cursor: 'pointer',
            fontSize: TYPO.sizes.xs, color: COLORS.nav }}>
          …celá správa ({riadky.length} riadkov)
        </button>
      )}
      {d.maOkolie && (
        <div style={{ marginTop: 4 }}>
          <button type="button" onClick={() => setOtvorene(v => !v)}
            style={{ border: 0, background: 'none', padding: '2px 0', font: 'inherit', cursor: 'pointer',
              fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
            {otvorene ? '▾' : '▸'} {[d.podpis ? 'podpis' : '', d.dolozka ? 'právna doložka' : ''].filter(Boolean).join(' a ')}
          </button>
          {otvorene && (
            <div style={{ marginTop: 3, paddingLeft: SPACE.sm, borderLeft: `2px solid ${COLORS.line}`,
              fontSize: TYPO.sizes.xs, color: COLORS.muted, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
              {[d.podpis, d.dolozka].filter(Boolean).join('\n\n')}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
